import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Cursor from "@/components/Cursor";
import FloatingContact from "@/components/FloatingContact";
import AppointmentModal from "@/components/AppointmentModal";
import BagDrawer from "@/components/BagDrawer";
import Home from "@/pages/Home";
import Catalogue from "@/pages/Catalogue";
import ProductDetail from "@/pages/ProductDetail";
import BridalPage from "@/pages/Bridal";
import CustomPage from "@/pages/Custom";
import About from "@/pages/About";
import Guide from "@/pages/Guide";
import GuideArticle from "@/pages/GuideArticle";
import Visit from "@/pages/Visit";
import Contact from "@/pages/Contact";
import Faq from "@/pages/Faq";
import Wishlist from "@/pages/Wishlist";
import Admin from "@/pages/Admin";
import NotFound from "@/pages/NotFound";

const AnimatedRoutes = () => {
    const location = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname, location.search]);
    return (
        <AnimatePresence mode="wait">
            <motion.div
                key={location.pathname + location.search}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.35, ease: "easeOut" }}
            >
                <motion.div
                    className="fixed top-0 left-0 right-0 h-px bg-gold z-[90] origin-left pointer-events-none"
                    initial={{ scaleX: 0, opacity: 1 }}
                    animate={{ scaleX: 1, opacity: 0 }}
                    transition={{ duration: 0.8, ease: "easeInOut" }}
                />
                <Routes location={location}>
                    <Route path="/" element={<Home />} />
                    <Route path="/collections" element={<Catalogue />} />
                    <Route path="/product/:slug" element={<ProductDetail />} />
                    <Route path="/bridal" element={<BridalPage />} />
                    <Route path="/custom" element={<CustomPage />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/guide" element={<Guide />} />
                    <Route path="/guide/:slug" element={<GuideArticle />} />
                    <Route path="/visit" element={<Visit />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/faq" element={<Faq />} />
                    <Route path="/wishlist" element={<Wishlist />} />
                    <Route path="/admin" element={<Admin />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </motion.div>
        </AnimatePresence>
    );
};

function App() {
    useEffect(() => {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
        };
    }, []);

    return (
        <div className="App bg-obsidian text-ivory min-h-screen">
            <BrowserRouter>
                <Cursor />
                <Navbar />
                <AnimatedRoutes />
                <Footer />
                <FloatingContact />
                <AppointmentModal />
                <BagDrawer />
            </BrowserRouter>
            <Toaster theme="dark" position="top-center" />
        </div>
    );
}

export default App;
